import React from 'react';
import { Box } from '@chakra-ui/react';

export function Fold({ variation, children, ...props }) {
  return (
    <Box
      position='relative'
      py={{ base: '8', md: '16', lg: '24' }}
      color={variation === 'dark' ? 'oci.surface' : undefined}
      bg={variation === 'dark' ? 'oci.primary' : undefined}
      {...props}
    >
      {children}
    </Box>
  );
}

export function FoldInner({ children, ...props }) {
  return (
    <Box
      display='grid'
      gridTemplateColumns={{
        base: 'repeat(4, 1fr)',
        md: 'repeat(8, 1fr)',
        lg: 'repeat(12, 1fr)'
      }}
      rowGap={{ base: '8', md: '12', xl: '16' }}
      columnGap={{ base: '4', md: '8', xl: '12' }}
      px={{ base: '4', md: '8', xl: '12' }}
      mx='auto'
      w='full'
      maxW='layout-max'
      {...props}
    >
      {children}
    </Box>
  );
}

export function Container({ children }) {
  return (
    <Box
      gridColumn={{ base: '1 / span 4', md: '2 / span 6', lg: '3 / span 8' }}
    >
      {children}
    </Box>
  );
}
